import React from 'react';
import View from '../elements/View';
import { Col, FormGroup, Input, InputGroup, Label } from 'reactstrap';
import { T } from '../helpers/i18n';
import { EditorConvertToHTML } from './EditorConverToHTML';
import { Fields, Languages, ViewSelected } from '../modules/Stretches/container/DataWeb';
import { Tags } from '../modules/Stretches/container/Tags';
import RichTextEditor from './RichTextEditor/RichTextEditor';
export var EditorLanguage = function (props) {
    var viewSelected = props.viewSelected, languageSelected = props.languageSelected, editorStateCopied = props.editorStateCopied, onEditorStateCopied = props.onEditorStateCopied, editorStateTermCopied = props.editorStateTermCopied, onChange = props.onChange;
    return (React.createElement(React.Fragment, null, Object.entries(Languages).map(function (language) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (languageSelected === language[1]) {
            var dataweb = props.dataweb || {};
            if (!dataweb.array) {
                dataweb.array = {};
            }
            if (!dataweb.array[Fields.custom]) {
                dataweb.array[Fields.custom] = {};
            }
            if (!dataweb.array[Fields.terminosCondiciones]) {
                dataweb.array[Fields.terminosCondiciones] = {};
            }
            /*if (!dataweb.array[language[1]]) {
              dataweb.array[language[1]] = ''
            }*/
            // console.log('dataweb: ', dataweb)
            return (React.createElement(View, { key: "view ".concat(language), style: { margin: '20px' } },
                viewSelected === ViewSelected.infoDataweb && React.createElement(FormGroup, { row: true },
                    React.createElement(Label, { for: 'placeholder', md: 5, sm: 12 }, T('askAdditionalInformation')),
                    React.createElement(Col, { md: 7, sm: 12 },
                        React.createElement(InputGroup, null,
                            React.createElement(Input, { placeholder: T('askAdditionalInformation'), name: 'placeholder', type: 'text', value: dataweb.array[Fields.placeholder] && dataweb.array[Fields.placeholder][languageSelected], onChange: function (e) {
                                    var value = e.target.value;
                                    onChange({ value: value, field: 'placeholder', lang: languageSelected });
                                } })))),
                viewSelected === ViewSelected.infoDataweb &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Label, null, T('description')),
                        React.createElement(RichTextEditor, { initialContent: dataweb.array[Fields.custom][languageSelected], onEditorAccept: function (cleanHtml) {
                                props.onChange({
                                    value: cleanHtml,
                                    field: Fields.custom,
                                    lang: language[1]
                                });
                            } })),
                viewSelected === ViewSelected.termsDataweb && React.createElement(React.Fragment, null,
                    React.createElement(Label, null, T('terminosCondiciones')),
                    React.createElement(EditorConvertToHTML, { key: Fields.terminosCondiciones + language[1], editorStateCopied: editorStateTermCopied, language: language[1], nameField: Fields.terminosCondiciones, contentHtml: dataweb.array[Fields.terminosCondiciones][languageSelected], onEditorStateCopied: function (editorState) {
                            props.onEditorStateCopied({ editorStateTermCopied: editorState });
                        }, onEditorChange: function (html, lang) {
                            if (!props.onChange)
                                return;
                            props.onChange({
                                value: html,
                                field: Fields.terminosCondiciones,
                                lang: lang
                            });
                        } })),
                viewSelected === ViewSelected.tags && React.createElement(React.Fragment, null,
                    React.createElement(Tags, { hrefValue: (_c = (_b = (_a = dataweb === null || dataweb === void 0 ? void 0 : dataweb.array) === null || _a === void 0 ? void 0 : _a[Fields.tags]) === null || _b === void 0 ? void 0 : _b[languageSelected]) === null || _c === void 0 ? void 0 : _c['href'], destinationValue: (_d = dataweb['destination']) === null || _d === void 0 ? void 0 : _d.id, categoryValue: Array.isArray(dataweb['category']) ?
                            (_e = dataweb['category']) === null || _e === void 0 ? void 0 : _e.map(function (category) { return category.id; }) :
                            // @ts-ignore
                            [(_f = dataweb['category']) === null || _f === void 0 ? void 0 : _f.id], 
                        // @ts-ignore
                        tagValue: (_g = dataweb['tag']) === null || _g === void 0 ? void 0 : _g.map(function (tag) { return tag.id; }), 
                        // tags={dataweb.array[Fields.tags] || {}}
                        tags: props.tags.sort(sortCallback(languageSelected)), destinations: props.destinations, categories: props.categories.sort(sortCallback(languageSelected)), language: languageSelected, onChange: function (_a) {
                            var value = _a.value, field = _a.field, lang = _a.lang;
                            if (!onChange)
                                return;
                            return onChange({ value: value, field: field, lang: lang });
                        } }))));
        }
        else
            return null;
    })));
};
var sortCallback = function (languageSelected) { return function (a, b) {
    var _a, _b;
    var aName = a.name;
    var bName = b.name;
    if ((_a = a.value) === null || _a === void 0 ? void 0 : _a[languageSelected]) {
        aName = a.value[languageSelected];
    }
    if ((_b = b.value) === null || _b === void 0 ? void 0 : _b[languageSelected]) {
        bName = b.value[languageSelected];
    }
    return aName.localeCompare(bName);
}; };



//////////////////
// WEBPACK FOOTER
// ./src/components/EditorLanguage.tsx
// module id = 1404
// module chunks = 0